import {Injectable} from '@angular/core';
import {EntityClass} from '../../entity.class';
import {entityDecorator} from '../../entity.decorator';

@Injectable()
@entityDecorator({
  url: 'api/mentalseal/v1/admin/organization',
  name: 'organization',
  protobufJSON: require('assets/protobuf/ownerManage/ownerManage.json'),
  protobufModule: 'Organization'
})
export class OrganizationForAdminService extends EntityClass {

}



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/services/entity-base/entity-service/ownerRoleManage/organization-for-admin.service.ts